// const baseUrl = 'https://520emv.com';
const baseUrl = `https://${window.location.host}`;
// const baseUrl = 'http://10.0.3.37:9096';
export const menu = [
    {
        childmenu: "tagdatashow",
        targetType: "operateFunc",
        menuName: "数据展示",
    },
    {
        childmenu: "navconfig",
        menuName: "导航配置",
        targetType: "none",
        children: [{
            childmenu: "wznavchoose",
            menuName: "网站导航优先级选择",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/flow/data?resourceAppId=wzsqzptx&targetTypes=top-nav&&appId=#appId"
        },
        {
            childmenu: "mainnavchoose",
            menuName: "主导航优先级选择",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/flow/data?resourceAppId=zjsqwzptxcp&types=main-nav&appId=#appId"
        },
        {
            childmenu: "subnavchoose",
            menuName: "副导航优先级选择",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/flow/data?resourceAppId=zjsqwzptxcp&types=sub-nav-priority&appId=#appId"
        }]
    },
    {
        childmenu: "themeParamsConfig",
        redirectUrl: baseUrl+"/zciid-deliverable/business/bAppOqmidPage/list?appId=#appId",
        targetType: "opeFrame",
        menuName: "主题参数配置",
    },
    {
        childmenu: "yulanwaizhan",
        menuName: "预览外展",
        targetType: "none",
    },
    {
        childmenu: "showFrame",
        targetType: "none",
        menuName: "外展展示架构配置",
        children: [{
            childmenu: "showFrameConfig",
            menuName: "外展展示架构配置",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/dict/data?types=extented_wzlcpz&appId=#appId",
        }, {
            childmenu: "winAllFrameChoose",
            menuName: "楼层架构全局配置",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/business/flowSpit/selectShowFlowPositionAll?flowOrDetail=flow&appId=#appId",
        }, {
            childmenu: "winFrameChoose",
            menuName: "楼层架构个性配置",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/business/flowSpit/selectShowFlowPosition?flowOrDetail=flow&flowId=#flowId"
        }, {
            childmenu: "winAllFrameDetailChoose",
            menuName: "详情架构全局配置",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/business/flowSpit/selectShowFlowPositionAll?flowOrDetail=detail&appId=#appId",
        },
        {
            childmenu: "winFrameDetailChoose",
            menuName: "详情架构个性配置",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/business/flowSpit/selectShowFlowPosition?flowOrDetail=detail&flowId=#flowId"
        }
        ]
    },
    {
        childmenu: "floorFlowDataConfig",
        targetType: "none",
        menuName: "楼层流程数据配置",
        children: [
            {
                childmenu: "wzprojectDataConfig",
                menuName: "外展立项数据配置",
                targetType: "opeFrame",
                redirectUrl: baseUrl+"/zciid-deliverable/flow/flow/list?appId=#appId"
            },
            {
                childmenu: "flowFloorChoose",
                menuName: "楼层流程上端选择",
                targetType: "opeFrame",
                redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/flow/data?types=flow-nav-prioroty&appId=#appId"
            },
            {
                childmenu: "flowFloorChoose",
                menuName: "楼层流程下端选择",
                targetType: "opeFrame",
                redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/flow/data?types=floor-bottom-prioroty&appId=#appId"
            },
            {
                childmenu: "flowFloorChoose",
                menuName: "楼层流程左侧选择",
                targetType: "opeFrame",
                redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/flow/data?types=floor-left-prioroty&appId=#appId"
            },
            {
                childmenu: "flowFloorChoose",
                menuName: "楼层流程右侧选择",
                targetType: "opeFrame",
                redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/flow/data?types=floor-right-prioroty&appId=#appId"
            },
            {
                childmenu: "flowFloorChoose",
                menuName: "楼层流程中间块选择",
                targetType: "opeFrame",
                redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/flow/data?types=floor-center-prioroty&appId=#appId"
            },
            {
                childmenu: "floorLeftCircleChoose",
                menuName: "楼层左侧商圈选择",
                targetType: "opeFrame",
                redirectUrl: baseUrl+"/zciid-deliverable/business/flowSpit/selectCirclePage?appId=#appId&flowId="
            },
        ]
    },
    {
        childmenu: "detailDataConfig",
        menuName: "详情流程数据配置",
        targetType: "none",
        children: [{
            childmenu: "flowFloorChooseDetail",
            menuName: "详情流程上端选择",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/flow/data?types=detail-up-block&appId=#appId"
        },
        {
            childmenu: "flowFloorChooseDetail",
            menuName: "详情流程左侧选择",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/flow/data?types=detail-left-block&appId=#appId"
        },
        {
            childmenu: "flowFloorChooseDetail",
            menuName: "详情流程右侧选择",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/app/api/config/select/flow/data?types=detail-right-block&appId=#appId"
        },
        {
            childmenu: "detailLeftCircleChoose",
            menuName: "详情左侧商圈选择",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/business/flowSpit/selectCirclePage?appId=#appId&flowId="
        }
        ]
    },
    {
        childmenu: "platDeliveryConfig",
        menuName: "平台交付物配置",
        targetType: "opeFrame",
        redirectUrl: baseUrl+"/zciid-deliverable/app/excel/init"
    },
    {
        childmenu: "option",
        menuName: "操作工具",
        targetType: "none",
        children: [{
            childmenu: "leftMove",
            menuName: "左移",
            targetType: "operateFunc",
            redirectUrl: baseUrl+"/zciid-deliverable/showPlatformStyle/flow/api/updateTRecordContentShowRowsSort"
        },
        {
            childmenu: "rightMove",
            menuName: "右移",
            targetType: "operateFunc",
            redirectUrl: baseUrl+"/zciid-deliverable/showPlatformStyle/flow/api/updateTRecordContentShowRowsSort"
        },
        {
            childmenu: "lunbopeizhi",
            targetType: "operateFunc",
            menuName: "轮播配置",
            redirectUrl: baseUrl+"/zciid-deliverable/showPlatformStyle/flow/api/updateShowFlowPosition?childmenu=on&flowOrDetail=floor-slideshow&flowId=#flowId"
        }, {
            childmenu: "huanyuanlunbopeizhi",
            targetType: "operateFunc",
            menuName: "还原轮播配置",
            redirectUrl: baseUrl+"/zciid-deliverable/showPlatformStyle/flow/api/updateShowFlowPosition?childmenu=off&flowOrDetail=floor-slideshow&flowId=#flowId"
        }, {
            childmenu: "calTopDefaultProcess",
            targetType: "operateFunc",
            menuName: "取消上端默认流程",
            redirectUrl: baseUrl+"/zciid-deliverable/showPlatformStyle/flow/api/updateShowFlowPosition?childmenu=off&flowOrDetail=flow-slideshow&flowId=#flowId"
        }, {
            childmenu: "setTopDefaultProcess",
            targetType: "operateFunc",
            menuName: "还原上端默认流程",
            redirectUrl: baseUrl+"/zciid-deliverable/showPlatformStyle/flow/api/updateShowFlowPosition?childmenu=off&flowOrDetail=flow-slideshow&flowId=#flowId"

        }
        ]
    },
    {
        childmenu: "changeType",
        targetType: "none",
        menuName: "更换展示方式",
        children: [{
            childmenu: "changeFlowType",
            menuName: "更换流程架构展示方式",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/business/flow/list?workId=&sceneGroupId=&historyId=&appId=#appId"
        },{
            childmenu: "changeBlockType",
            menuName: "更换中间块展示方式",
            targetType: "opeFrame",
            redirectUrl: baseUrl+"/zciid-deliverable/business/flowSpit/floweditFloorStyle?flowId=#flowId"
        }]
    }
]

export const appendMenu = [
    {
        childmenu: "wzRightMenuConfig",
        targetType: "opeFrame",
        menuName: "暂无数据",
        redirectUrl: ''
    //     childmenu: "wzRightMenuConfig",
    //     targetType: "opeFrame",
    //     menuName: "外展主页右键配置",
    //     redirectUrl: baseUrl+"/zciid-deliverable/activity/flowbutton/chooseButton?types=260&flowId=parentId=buttonTypes002001004004"
    // },{
    //     childmenu: "wzRightMenuConfig",
    //     targetType: "opeFrame",
    //     menuName: "外展详情右键配置",
    //     redirectUrl: baseUrl+"/zciid-deliverable/activity/flowbutton/chooseButton?types=163&flowId=parentId=buttonTypes002001004004"
    }
]

// export const authLoginMenu = [{
//     childmenu: "openFloorLive",
//     targetType: "operateFunc",
//     menuName: "开启直播",
//     redirectUrl: baseUrl+"/zciid-deliverable/activity/flowbutton/chooseButton?types=163&flowId=parentId=buttonTypes002001004004"
// }]

//将开启直播放在右键工具下一级
export const authLoginMenu = [{
    boxNewList: [{childmenu: "openFloorLive",
    menuName: "开启直播",
    redirectUrl:  baseUrl+"/zciid-deliverable/activity/flowbutton/chooseButton?types=163&flowId=parentId=buttonTypes002001004004",
    targetType: "operateFunc",
    types: null,
    verticalUrl: null}],
    menuLevel: 2,
    menuName: "frameOpreateTool"
}]



// WEBPACK FOOTER //
// ./src/menu.js